"use client";

import { FaceSmileIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import { ComponentPropsWithoutRef, FC, useEffect, useState } from "react";

type AvatarProps = {
  src?: any;
  // Override the default "Avatar" alt with something descriptive. Used by
  // `TrustedBy` to give each social-proof avatar a meaningful, SEO-/
  // screen-reader-friendly label rather than the generic placeholder.
  alt?: string;
} & ComponentPropsWithoutRef<"div">;

const Avatar: FC<AvatarProps> = ({ src, alt, ...rest }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [failedToLoad, setFailedToLoad] = useState(false);

  useEffect(() => {
    setImageSrc(src);
    setFailedToLoad(false);
  }, [src]);

  return (
    <div
      {...rest}
      className={`${rest.className} shrink-0 flex-none rounded-full overflow-hidden flex items-center justify-center bg-slate-200 text-slate-400 dark:bg-white/20 dark:text-foreground-secondary box-content`}
    >
      {imageSrc && !failedToLoad ? (
        <Image
          blurDataURL="/images/placeholder.png"
          placeholder="blur"
          width={128}
          height={128}
          src={imageSrc}
          alt={alt ?? "Avatar"}
          onError={() => {
            if (imageSrc !== "/images/placeholder.png") {
              setImageSrc("/images/placeholder.png");
              return;
            }
            setFailedToLoad(true);
          }}
        />
      ) : (
        <FaceSmileIcon className="w-2/3 h-2/3" />
      )}
    </div>
  );
};

export default Avatar;
